var paragraph_default = {
  "fontElementMap": "hO7Pu",
  "elementSpacing": "_5nQ5b",
  "text": "lE99d _5nQ5b",
  "child": "_-16Jh"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
